import { ExternalLink } from "lucide-react";
import { CA, GMGN_URL, PUMPFUN_URL, SOLSCAN_TOKEN_URL, DEXSCREENER_URL, SHORTEN } from "../config";
import { copyCa } from "./CopyButton";
import Reveal, { SectionHead } from "./Reveal";

const LINKS = [
    { label: "PUMP.FUN", href: PUMPFUN_URL, testId: "buy-pumpfun-link" },
    { label: "DEXSCREENER", href: DEXSCREENER_URL, testId: "buy-dexscreener-link" },
    { label: "SOLSCAN", href: SOLSCAN_TOKEN_URL, testId: "buy-solscan-link" },
    { label: "GMGN", href: GMGN_URL, testId: "buy-gmgn-link" },
];

export default function BuySection() {
    return (
        <section id="buy" data-testid="buy-section" className="relative scroll-mt-24 overflow-hidden py-24 lg:py-32">
            <div className="absolute inset-0 bg-[radial-gradient(ellipse_55%_60%_at_50%_50%,rgba(0,240,255,0.08),transparent)]" />
            <div className="relative mx-auto max-w-4xl px-4 text-center sm:px-6">
                <SectionHead kicker="BUY $BALD" title="READY TO GET BALD?" />
                <Reveal delay={0.1}>
                    <p className="mx-auto mt-6 max-w-2xl text-base md:text-lg text-slate-400">
                        If you understand the risks and want to join the meme, you can find $BALD on the Solana
                        ecosystem.
                    </p>
                </Reveal>

                <Reveal delay={0.2}>
                    <a
                        href={GMGN_URL}
                        target="_blank"
                        rel="noopener noreferrer"
                        data-testid="buy-main-button"
                        className="btn-primary mt-10 !px-12 !py-5 text-xl"
                    >
                        BUY $BALD <ExternalLink className="h-5 w-5" />
                    </a>
                </Reveal>

                <Reveal delay={0.3}>
                    <div className="mt-8 grid grid-cols-2 gap-3 sm:grid-cols-4">
                        {LINKS.map((l) => (
                            <a
                                key={l.label}
                                href={l.href}
                                target="_blank"
                                rel="noopener noreferrer"
                                data-testid={l.testId}
                                className="glass glass-hover flex items-center justify-center gap-2 rounded-xl px-4 py-4 font-mono text-xs font-bold uppercase tracking-widest text-slate-200 hover:text-cyan-300"
                            >
                                {l.label} <ExternalLink className="h-3.5 w-3.5" />
                            </a>
                        ))}
                    </div>
                </Reveal>

                <Reveal delay={0.4}>
                    <button
                        type="button"
                        data-testid="buy-ca-copy-line"
                        onClick={copyCa}
                        className="mx-auto mt-8 flex max-w-full items-center gap-2 rounded-full border border-white/10 bg-white/[0.03] px-5 py-2.5 font-mono text-xs text-slate-400 hover:border-cyan-400/40 hover:text-cyan-300"
                        title="Click to copy"
                    >
                        <span className="uppercase tracking-widest">CA:</span>
                        <span className="truncate">{SHORTEN(CA, 14, 10)}</span>
                    </button>
                </Reveal>
            </div>
        </section>
    );
}
